<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-header>
        <div class="listtitle">投诉管理</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-row>
            <el-col :span="6">
              <el-form-item label="投诉人">
                <el-input
                  v-model="ComplaintPerson"
                  placeholder="请输入投诉人"
                ></el-input> </el-form-item
            ></el-col>
            <el-col :span="12">
              <el-form-item label="投诉日期">
                <el-date-picker
                  v-model="date"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 60rem"
                  unlink-panels
                  :clearable="false"
                ></el-date-picker> </el-form-item
            ></el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="投诉状态">
                <el-select v-model="ComplaintStatus" placeholder="请选择">
                  <el-option key label="全部" value=""></el-option>
                  <el-option
                    v-for="item in ComplaintStatusArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="6">
              <el-form-item label="投诉手机号">
                <el-input
                  v-model="ComplaintTel"
                  placeholder="请输入手机号"
                ></el-input> </el-form-item
            ></el-col>
            <el-form-item label class="right">
              <el-button @click="onSearch">查 询</el-button>
              <el-button @click="onCancel">清 理</el-button>
            </el-form-item>
          </el-row>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="sn"
                label="编号"
              ></el-table-column>
              <el-table-column
                prop="content"
                label="投诉内容"
              ></el-table-column>
              <el-table-column
                prop="platform"
                label="投诉来源"
                :formatter="SourceToNameConverter"
              ></el-table-column>
              <el-table-column
                prop="createdate"
                label="投诉时间"
                show-overflow-tooltip
                :formatter="formatDate"
              ></el-table-column>
               <el-table-column
                prop="heavyacceptdate"
                label="重诉受理时间"
                show-overflow-tooltip
                :formatter="formatDate"
              ></el-table-column>
               <el-table-column
                prop="figureoutdate"
                label="结案时间"
                show-overflow-tooltip
                :formatter="formatDate"
              ></el-table-column>
              <el-table-column prop="name" label="投诉人">
              </el-table-column>
              <el-table-column
                prop="phone"
                label="联系电话"
              ></el-table-column>
              <el-table-column
                prop="status"
                label="投诉状态"
                :formatter="StatusToNameConverter"
              ></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      v-if="scope.row.status=='0'||scope.row.status=='1'||scope.row.status=='4'||scope.row.status=='5'"
                      @click="queryEdit(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >处理</el-button>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import ComplaintApi from "../../../apis/src/ComplaintApi";

export default {
  name: "ComplaintAllDealView",
  controller: "UI",
  action: "ComplaintAllDealView",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      ComplaintPerson: "",
      ComplaintTel: "",
      loading: false,
      loadingText: "加载中...",
      date: [new Date(new Date() - 30 * 24 * 60 * 60 * 1000), new Date()],
      ComplaintSourceArr: [
        { value: 1, label: "app安卓" },
        { value: 2, label: "appiOS" },
        { value: 3, label: "官网" },
        { value: 4, label: "公众号" },
        { value: 5, label: "小程序" },
        { value: 6, label: "其他" },
      ],
      ComplaintStatus: "",
      ComplaintStatusArr: [
        { value: 0, label: "待受理" },
        { value: 1, label: "已受理" },
        { value: 2, label: "不予受理" },
        { value: 3, label: "处理完成" },
        { value: 4, label: "重诉待受理" },
        { value: 5, label: "重诉已受理" },
        { value: 6, label: "已完结" },
      ],
    };
  },
  created: function () {
  },
  mounted: function () {
    this.search();
    this.logInfo.ActionName = "投诉查询";
    this.logInfo.LogMessage = "投诉查询";
    this.logInfo.ModuleName = "投诉系统";
    this.logInfo.PageName = "投诉查询列表";
    this.addOperationLog();
  },
  methods: {
    search() {
      let searchInfo = {
        createdate1:
          this.date == null
            ? "0001-01-01T00:00:00"
            : this.date[0].format("yyyy-MM-dd 00:00:00"),
        createdate2:
          this.date == null
            ? "0001-01-01T00:00:00"
            : this.date[1].format("yyyy-MM-dd 23:59:59"),
        status: this.ComplaintStatus,
        person: this.ComplaintPerson,
        tel: this.ComplaintTel,
        size: this.pageSize,
        page: this.currentPage,
      };
      this.loading = true;
      ComplaintApi.GetSuggestList(searchInfo)
        .then((r) => {
          this.tableData = r.data;
          this.total = r.count;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/complaint/ui/ComplaintAllDealInfo",
        query: { Info: row,InfoId:row.id, type: "query" },
      });
    },
    //处理
    queryEdit(index, row) {
      this.$router.push({
        path: "/plugin/complaint/ui/ComplaintAllDealInfo",
        query: { Info: row,InfoId:row.id, type: "edit" },
      });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.ComplaintPerson = "";
      this.ComplaintStatus = "";
      this.ComplaintTel = "";
      this.date = [new Date(new Date() - 30 * 24 * 60 * 60 * 1000), new Date()];
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    SourceToNameConverter(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      const SourceName = this.ComplaintSourceArr.map((item) => {
        if (item.value == data) return item.label;
      }).join("");
      if (SourceName == null || SourceName == "") {
        return data;
      }
      return SourceName;
    },
    StatusToNameConverter(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      const StatusName = this.ComplaintStatusArr.map((item) => {
        if (item.value == data) return item.label;
      }).join("");
      if (StatusName == null || StatusName == "") {
        return data;
      }
      return StatusName;
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm");
    },
  },
};
</script>
